import { render, staticRenderFns } from "./ModalUserName.vue?vue&type=template&id=01fb3f0a"
import script from "./ModalUserName.vue?vue&type=script&lang=js"
export * from "./ModalUserName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports